<template>
  <!-- 发货 -->
  <div class="wrapper">
    <admin-title title="发货"></admin-title>

    <div class="header">
      <el-tabs v-model="activeName">
        <el-tab-pane v-if="deliveryType == 1" label="物流配送" name="1"></el-tab-pane>
        <el-tab-pane v-if="deliveryType == 2" label="门店自提" name="2"></el-tab-pane>
      </el-tabs>

      <div class="tip-hit" v-if="tip">
        <span class="tip">
          <i class="el-icon-warning"></i>
          该用户与<span style="font-weight: 700; color: #000" >{{ tip }}</span>
          库中数据匹配，请复核后谨慎操作！
        </span>
      </div>
    </div>

    <!-- 物流订单 -->
    <DeliveryExpress v-if="activeName == 1"></DeliveryExpress>
    <!-- 自提订单 -->
    <DeliveryPick v-if="activeName == 2"></DeliveryPick>
  </div>
</template>

<script>
import { dict_order_type } from "@/enum/dict/index.js";
import DeliveryExpress from "./delivery-express.vue";
import DeliveryPick from "./delivery-pick.vue";

export default {
  name: "Delivery",
  components: { DeliveryExpress, DeliveryPick },
  data() {
    return {
      activeName: "1",
      dict_order_type,
      deliveryType: 1,
      tip: "",
    };
  },
  watch: {
    deliveryType: {
      immediate: true,
      handler(newV, oldV) {
        if (this.deliveryType == 2) {
          this.activeName = "2";
        } else {
          this.activeName = "1";
        }
      },
    },
  },
  mounted() {
    this.deliveryType = localStorage.getItem("deliveryType");
    this.hit();
  },

  methods: {
    // 撞库
    async hit() {
      let arr = [];
      const rosterLevelList = JSON.parse(
        localStorage.getItem("rosterLevelList"),
      );
      rosterLevelList.forEach((item) => {
        if (item == 2) {
          arr.push("黑名单");
        } else if (item == 3) {
          arr.push("灰名单");
        } else if (item == 1) {
          arr.push("白名单");
        }
      });
      this.tip = arr.join("、");
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          handleDeliveryAPI(this.formData).then(() => {
            this.$message.success("发货成功");
            //
            setTimeout(() => {
              this.closePage();
            }, 1000);
          });
        }
      });
    },
    emitAwindow() {
      if (window.opener) {
        if (window.opener.getBpageList) {
          window.opener.getBpageList();
        } else {
          window.opener.frames[0].getBpageList();
        }
      }
    },
    closePage() {
      this.emitAwindow();
      window.close();
      localStorage.removeItem("deliveryType");
      localStorage.removeItem("rosterLevelList");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header {
    position: relative;
    .tip-hit {
      position: absolute;
      width: 500px;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      background-color: #f9d7d9;
      padding: 8px 5px;
      border-radius: 2px;
      font-weight: 600;
      i {
        color: #e34d59;
        font-size: 16px;
        vertical-align: baseline;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
  }

  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }

  .goods-sku,
  .baseInfo-2 {
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 60px;
      height: 60px;
      line-height: 60px;
      text-align: center;
    }

    .avatar {
      width: 60px;
      height: 60px;
      display: block;
    }
  }
}
</style>
